module.exports = __webpack_public_path__ + "static/media/info-icon.98f7d1b5.svg";